import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  speedLearnTopicBySubjectIdAsync,
  speedLearnByTopicIdAsync,
} from "./speedlearn.async";

const initialState = {
  speedlearntopicsLoader: false,
  speedlearntopics: [],
  speedLearnVideoLoader: false,
  speedLearnVideo: [],
};

export const speedLearnSlice = createSlice({
  name: "speedlearn",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(speedLearnTopicBySubjectIdAsync.pending),
      (state) => {
        state.speedlearntopicsLoader = true;
        state.speedlearntopics = [];
      }
    );
    builder.addMatcher(
      isAnyOf(speedLearnTopicBySubjectIdAsync.fulfilled),
      (state, action) => {
        state.speedlearntopicsLoader = false;
        state.speedlearntopics = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(speedLearnTopicBySubjectIdAsync.rejected),
      (state, action) => {
        state.speedlearntopicsLoader = false;
        state.speedlearntopics = [];
      }
    );

    builder.addMatcher(isAnyOf(speedLearnByTopicIdAsync.pending), (state) => {
      state.speedLearnVideoLoader = true;
      state.speedLearnVideo = [];
    });
    builder.addMatcher(
      isAnyOf(speedLearnByTopicIdAsync.fulfilled),
      (state, action) => {
        state.speedLearnVideoLoader = false;
        state.speedLearnVideo = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(speedLearnByTopicIdAsync.rejected),
      (state, action) => {
        state.speedLearnVideoLoader = false;
        state.speedLearnVideo = [];
      }
    );
  },
  reducers: {
    emptyspeedlearn: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const { emptyspeedlearn } = speedLearnSlice.actions;

export default speedLearnSlice.reducer;
